function getGenericStatusBarData(
    data,
    column,
    prefix = '',
    includeGreen = false,
    includeMaintenance = false
) {
    let statusBarData = []
    if (!data) return statusBarData
    if (data[`${prefix}red_${column}`]) {
        statusBarData.push({
            variant: 'danger',
            count: data[`${prefix}red_${column}`],
        })
    }
    if (data[`${prefix}orange_${column}`]) {
        statusBarData.push({
            variant: 'warning',
            count: data[`${prefix}orange_${column}`],
        })
    }
    if (data[`${prefix}yellow_${column}`]) {
        statusBarData.push({
            variant: 'busy',
            count: data[`${prefix}yellow_${column}`],
        })
    }
    if (includeMaintenance && data[`maintenance_${column}`]) {
        statusBarData.push({
            variant: 'neutral',
            count: data[`maintenance_${column}`],
        })
    }
    if (includeGreen && data[`${prefix}green_${column}`]) {
        statusBarData.push({
            variant: 'success',
            count: data[`${prefix}green_${column}`],
        })
    }
    return statusBarData
}

export function getDevicesStatusBarData(
    data,
    includeGreen = false,
    includeMaintenance = false
) {
    return getGenericStatusBarData(
        data,
        'devices',
        '',
        includeGreen,
        includeMaintenance
    )
}

export function getConfigurationStatusBarData(data, includeGreen = true) {
    return getGenericStatusBarData(
        data,
        'configurations',
        '',
        includeGreen,
        false
    )
}

export function getMaintenanceDevicesStatusBarData(data, includeGreen = true) {
    return getGenericStatusBarData(
        data,
        'devices',
        'maintenance_',
        includeGreen,
        false
    )
}

export function getEventsStatusBarData(data) {
    let barData = getGenericStatusBarData(data, 'events')
    if (data.maintenance) {
        barData.push({ variant: 'grey' })
    } else if (barData.length === 0) {
        barData.push({ variant: 'success' })
    }
    return barData
}

const statusBarDataObject = {
    getEventsStatusBarData,
    getDevicesStatusBarData,
    getConfigurationStatusBarData,
    getMaintenanceDevicesStatusBarData,
}

export default statusBarDataObject
